export const RoutingStateChangedKey = 'RoutingStateChanged';

export interface RoutingStateChanged {
  context?: any;
}
